import { env, buildVersion } from '../../env'
import { useTranslation } from 'react-i18next'

export function StageBanner() {
  const { t } = useTranslation()

  if (!env.isStage) return null

  return (
    <div className="bg-amber-400 text-amber-900 text-sm font-medium px-4 py-1.5 text-center sticky top-0 z-50">
      {t('stage.banner')}{' '}
      <span className="opacity-75 font-normal">{t('stage.version')} {buildVersion}</span>
    </div>
  )
}
